const INITIAL_STATE: any = {
  categories: [],
  companies: [],
  companiesFromUser: [],
  projects: [],
  dockyards: [],
  edbs: [],
  ops: [],
  users: [],
  preparation: [],
  stocks: [],
  entrepots: [],
  products: [],
  wmsConfigs: [],
  packageTypes: [],
  loading: false,
  pending: false,
  projectLoader: false,
  dockyardsLoader: false,
  companiesLoader: false,
  companiesFromUserLoader: false,
  usersLoader: false,
  edbsLoader: false,
  opsLoader: false,
  preparationsLoader: false,
  entrepotsLoader: false,
  productsLoader: false,
  packageTypesLoader: false,
  refreshCategoryDate: new Date(),
  wmsConfigLoader: false,
  socket: null,
};

const apiReducer = (state = INITIAL_STATE, action: any = null): any => {
  switch (action.type) {
    case "LOAD_API": {
      return { ...state, loading: true };
    }
    case "LOADOUT_API": {
      return { ...state, loading: false };
    }
    case "PENDING_API": {
      return { ...state, pending: true };
    }
    case "PENDING_END_API": {
      return { ...state, pending: false };
    }
    case "PUSH_CATEGORIES":
      if (!!action.payload.categories?.length && !!state?.products?.length) {
        // map products with categories
        const catprod = {};

        (action.payload.categories || []).forEach((c) => {
          c.products.forEach((pid) => {
            if (!catprod[pid]) {
              catprod[pid] = [];
            }
            catprod[pid].push(c.id);
          });
        });
        const _products = state.products?.map((p: any) => {
          // eslint-disable-next-line no-param-reassign
          p.categories = catprod[p._id] || [];
          return p;
        });
        // eslint-disable-next-line no-param-reassign
        state.products = _products;
      }

      return {
        ...state,
        categories: action.payload.categories,
        loading: false,
        pending: false,
      };
    case "PUSH_COMPANIES":
      return {
        ...state,
        companies: action.payload.companies || [],
        companiesLoader: action.payload.companiesLoader || false,
      };
    case "PUSH_COMPANIES_FROM_USER":
      return {
        ...state,
        companiesFromUser: action.payload.companiesFromUser || [],
        companiesFromUserLoader:
          action.payload.companiesFromUserLoader || false,
      };
    case "PUSH_PROJECTS":
      return {
        ...state,
        projects: action.payload.projects || [],
        projectLoader: action.payload.projectLoader || false,
      };
    case "PUSH_DOCKYARDS":
      return {
        ...state,
        dockyards: action.payload.dockyards || [],
        dockyardsLoader: action.payload.dockyardsLoader || false,
      };
    case "PUSH_EDBS":
      return {
        ...state,
        edbs: action.payload.edbs || [],
        edbsLoader: action.payload.edbsLoader || false,
      };
    case "PUSH_OPS":
      return {
        ...state,
        ops: action.payload.ops,
        opsLoader: action.payload.opsLoader || false,
      };
    case "PUSH_USERS":
      return {
        ...state,
        users: action.payload.users || [],
        usersLoader: action.payload.usersLoader || false,
      };

    case "PUSH_PREPARATIONS":
      return {
        ...state,
        preparations: action.payload.preparations,
        preparationsLoader: action.payload.preparationsLoader || false,
      };
    case "PUSH_ENTREPOTS":
      return {
        ...state,
        entrepots: action.payload.entrepots,
        entrepotsLoader: action.payload.entrepotsLoader || false,
      };
    case "PUSH_PRODUCTS":
      return {
        ...state,
        products: action.payload.products,
        productsLoader: action.payload.productsLoader || false,
      };
    case "PUSH_STOCKS":
      return {
        ...state,
        stocks: action.payload.stocks,
      };
    case "PUSH_WMSCONFIGS":
      return {
        ...state,
        wmsConfigs: action.payload.wmsConfigs || [],
        wmsConfigLoader: action.payload.wmsConfigLoader || false,
      };
    case "PUSH_PACKAGE_TYPES":
      return {
        ...state,
        packageTypes: action.payload.packageTypes,
      };
    case "PUSH_ACTIVITIES":
      return {
        ...state,
        activities: action.payload.activities,
      };
    case "RESET_CATEGORIES":
      return {
        ...state,
        ...INITIAL_STATE,
        categories: [],
      };
    case "REFRESH_CATEGORIES":
      return {
        ...state,
        refreshCategoryDate: new Date(),
      };
    case "SETSOCKET":
      return {
        ...state,
        socket: action.payload.socket,
      };
    default:
      return state;
  }
};

export default apiReducer;
